import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import { CustomEventLogsModel } from '../models/custom-event-logs';

@Injectable({
  providedIn: 'root',
})
export class CustomEventLogsRepository {
  constructor(private apiService: ApiService) {}

  public logEvent(data: CustomEventLogsModel): Observable<never> {
    return this.apiService.post(`${environment.url.prefixCustoms}v2/custom-event-logs`, data);
  }
}
